// extracted by mini-css-extract-plugin
export default {"modal":"modalPaymentSubscriptionStyle_modal__8C2AK"};